export default {"src":"/_next/static/media/reading-card.colour.518d2827.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};